/** Accord singulier/pluriel : « reportage » → « reportages » dès 2. */
export function plural(n: number, singular: string, pluralForm?: string): string {
  return n > 1 ? (pluralForm ?? `${singular}s`) : singular;
}

/** « 1 reportage », « 2 reportages »… pour titres, meta et JSON-LD. */
export function countLabel(n: number, singular: string, pluralForm?: string): string {
  return `${n} ${plural(n, singular, pluralForm)}`;
}

/** Remplace un décompte {n} sans réécrire les autres noms du texte éditorial. */
export function countTemplate(template: string, n: number): string {
  const forms: Record<string, string> = {
    films: "film", vidéos: "vidéo", documentaires: "documentaire",
    épisodes: "épisode", émissions: "émission", chaînes: "chaîne",
    communes: "commune", reportages: "reportage", articles: "article",
    concerts: "concert", archives: "archive", extraits: "extrait",
    séquences: "séquence", fiches: "fiche", documents: "document",
    lieux: "lieu", années: "année", sources: "source",
  };
  return template.replace(/\{n\}(?:\s+([\p{L}]+))?/gu, (_match, word: string | undefined) => {
    if (!word) return String(n);
    const singular = forms[word];
    return singular ? countLabel(n, singular, word) : `${n} ${word}`;
  });
}
